<div class="settings-popup__window dialog__window">
  <div class="settings-popup__header dialog__header">
    <div class="settings-popup__title dialog__title">Настройки</div>
    <div class="settings-popup__close dialog__close" (click)="onClose()"><i class="icon-close"></i></div>
  </div>
  <div class="settings-popup__tabs dialog__tabs">
    <div
      class="settings-popup__tab dialog__tab"
      [class.settings-popup__tab_active]="activeTab() === 'user'"
      [class.dialog__tab_active]="activeTab() === 'user'"
      (click)="onChangeTab($event, 'user')"
    >
      Сотрудники
    </div>
    <div
      class="settings-popup__tab dialog__tab"
      [class.settings-popup__tab_active]="activeTab() === 'tag'"
      [class.dialog__tab_active]="activeTab() === 'tag'"
      (click)="onChangeTab($event, 'tag')"
    >
      Теги
    </div>
    <div
      class="settings-popup__solid dialog__solid"
      [ngStyle]="{ 'left.px': headerActiveLineLeft(), 'width.px': headerActiveLineWidth() }"
    ></div>
  </div>

  @switch (activeTab()) {
    @case ('user') {
      <div class="settings-popup__description dialog__description">
        <div class="settings-popup__icon">
          <svg
            width="63px"
            height="54px"
            viewBox="0 0 63 54"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <defs>
              <circle id="path-1" cx="22.5" cy="22.5" r="22.5"></circle>
            </defs>
            <g id="UI-kit" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="My_Projects" transform="translate(-338.000000, -262.000000)">
                <g id="Group-24" transform="translate(338.000000, 263.000000)">
                  <g id="Group-23">
                    <g id="Shape" transform="translate(10.000000, 1.000000)">
                      <mask id="mask-2" fill="white">
                        <use xlink:href="#path-1"></use>
                      </mask>
                      <use id="Mask" stroke="#354052" stroke-width="2" fill="#2AE2D3" xlink:href="#path-1"></use>
                      <path
                        d="M5.4294321,47.4691358 C5.4294321,48.0282389 4.9761895,48.4814815 4.41708642,48.4814815 C3.54357527,48.4814815 3.22302647,47.7234083 3.40785979,47.1349827 C3.59392053,37.1797912 12.0813998,29.4954444 22.7182716,29.4954444 C33.06554,29.4954444 41.4552913,36.3249085 42.0459912,45.4788983 C42.0520293,45.574603 42.058311,45.7450685 42.0654801,45.9909908 C42.069415,46.1259687 42.073529,46.2813245 42.0777681,46.4532176 C42.0831437,46.6711949 42.088449,46.9044852 42.0934549,47.1377395 C42.0964581,47.2776762 42.098696,47.3865908 42.0999362,47.4490333 C42.1111947,48.0158918 41.6547605,48.4814815 41.0877901,48.4814815 L25.7654321,48.4814815 C25.206329,48.4814815 24.7530864,48.0282389 24.7530864,47.4691358 C24.7530864,46.9100327 25.206329,46.4567901 25.7654321,46.4567901 L40.0525421,46.4567901 C40.0487795,46.3061139 40.0451317,46.1694716 40.0416485,46.0499893 C40.0351821,45.8281701 40.029385,45.6708557 40.0254098,45.6078324 C39.5078488,37.5872795 32.0545809,31.5201358 22.7182716,31.5201358 C13.4116705,31.5201358 6.01106743,37.9897851 5.46210814,46.4567901 L19.691358,46.4567901 C20.2504611,46.4567901 20.7037037,46.9100327 20.7037037,47.4691358 C20.7037037,48.0282389 20.2504611,48.4814815 19.691358,48.4814815 L4.36950617,48.4814815 L4.36950617,46.4567901 L5.46210814,46.4567901 C5.44042569,46.7912146 5.4294321,47.128755 5.4294321,47.4691358 Z"
                        fill="#354052"
                        fill-rule="nonzero"
                        mask="url(#mask-2)"
                      ></path>
                    </g>
                    <circle id="Oval-3-Copy-6" stroke="#2AE2D3" stroke-width="2" cx="57" cy="44" r="2"></circle>
                    <polygon id="Path-3" fill="#FFD580" points="29 49 33 52.5 36.5 49 33 35.5"></polygon>
                    <circle id="Oval-3-Copy-2" fill="#884FB0" cx="2" cy="30" r="2"></circle>
                    <circle id="Oval-3-Copy-4" stroke="#FFD580" stroke-width="2" cx="59.5" cy="2.5" r="2.5"></circle>
                    <g
                      id="noun_profile_937777"
                      transform="translate(24.000000, 8.000000)"
                      fill="#354052"
                      fill-rule="nonzero"
                    >
                      <g id="Group">
                        <g id="Shape">
                          <path
                            d="M14.8024691,12.3765432 L14.8024691,9.33950617 C14.8024691,5.84517715 11.9696377,3.01234568 8.47530864,3.01234568 C4.98097962,3.01234568 2.14814815,5.84517715 2.14814815,9.33950617 L2.14814815,12.3765432 C2.14814815,15.8708722 4.98097962,18.7037037 8.47530864,18.7037037 C11.9696377,18.7037037 14.8024691,15.8708722 14.8024691,12.3765432 Z M16.8271605,12.3765432 C16.8271605,16.9890784 13.0878438,20.7283951 8.47530864,20.7283951 C3.86277346,20.7283951 0.12345679,16.9890784 0.12345679,12.3765432 L0.12345679,9.33950617 C0.12345679,4.72697099 3.86277346,0.987654321 8.47530864,0.987654321 C13.0878438,0.987654321 16.8271605,4.72697099 16.8271605,9.33950617 L16.8271605,12.3765432 Z"
                          ></path>
                        </g>
                        <path
                          d="M10.5109203,24.0568624 C10.9022526,23.6575438 11.5432017,23.6510696 11.9425203,24.0424018 C12.3418389,24.433734 12.3483131,25.0746832 11.9569809,25.4740018 L9.47673399,28.004866 C9.2863283,28.1991575 9.02573957,28.308642 8.7537037,28.308642 L8.70308642,28.308642 C8.43105055,28.308642 8.17046182,28.1991575 7.98005614,28.004866 L5.49980922,25.4740018 C5.108477,25.0746832 5.11495123,24.433734 5.51426983,24.0424018 C5.91358843,23.6510696 6.55453756,23.6575438 6.94586979,24.0568624 L8.72839506,25.8757658 L10.5109203,24.0568624 Z"
                          id="Shape"
                        ></path>
                        <path
                          d="M6.34773648,40.6103135 L8.72839506,42.6804514 L11.110887,40.6087192 L8.74665055,31.3573592 L6.34773648,40.6103135 Z M8.72839506,43.9708951 L8.7537037,43.9417901 L8.7537037,42.9876543 L8.70308642,42.9876543 L8.70308642,43.9417901 L8.72839506,43.9708951 Z M9.73452776,27.0456413 L13.2271204,40.7123079 C13.3218904,41.0831471 13.1994066,41.4757275 12.910576,41.7268846 L9.41798339,44.7639216 C9.23375564,44.9241197 8.99784153,45.0123457 8.7537037,45.0123457 L8.70308642,45.0123457 C8.45894859,45.0123457 8.22303449,44.9241197 8.03880673,44.7639216 L4.54621414,41.7268846 C4.25642764,41.4748963 4.1341709,41.0806364 4.23054635,40.7089025 L7.77375623,27.0422358 C8.03635013,26.0293736 9.47545366,26.031873 9.73452776,27.0456413 Z"
                          id="Shape"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div class="settings-popup__description-group dialog__description-group">
          <div class="settings-popup__description-text dialog__description-text">Сотрудники проекта</div>
          <div class="settings-popup__description-content dialog__description-content">
            Добавьте сотрудников, введя адрес электронной почты
          </div>
        </div>
      </div>
      <app-setting-invite></app-setting-invite>
    }
    @case ('tag') {
      <div class="settings-popup__description dialog__description">
        <div class="settings-popup__icon">
          <svg
            width="54px"
            height="55px"
            viewBox="0 0 54 55"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g id="UI-kit" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Tags-" transform="translate(-341.000000, -260.000000)">
                <g id="Group-22" transform="translate(341.000000, 261.000000)">
                  <g id="Group-25">
                    <path
                      d="M8.60158441,10.2480479 L12.5955369,7.68188516 C12.9137703,7.47741641 13.2834633,7.36738549 13.6617118,7.36456189 L40.1746203,7.16664512 C41.2791591,7.15839983 42.1812488,8.04712125 42.189494,9.15165997 C42.1895312,9.15663636 42.1895498,9.16161287 42.1895498,9.1665894 L42.1895498,22.514304 C42.1895498,23.6130477 41.3031922,24.5060465 40.2044792,24.5142483 L13.6779277,24.7122669 C13.2895207,24.7151664 12.9086739,24.6049037 12.581894,24.3949437 L8.60158441,21.8375467 C8.02890358,21.4695923 7.68268873,20.8356266 7.68268873,20.1549257 L7.68268873,11.9306689 C7.68268873,11.249968 8.02890358,10.6160023 8.60158441,10.2480479 Z"
                      id="Rectangle-9"
                      stroke="#354052"
                      stroke-width="2"
                      fill="#884FB0"
                      transform="translate(24.936119, 15.939455) rotate(-15.000000) translate(-24.936119, -15.939455) "
                    ></path>
                    <path
                      d="M9.13168883,14.017253 L13.5278872,11.1926424 C13.8484529,10.9866751 14.2211845,10.8765662 14.6022136,10.8752749 L44.1608428,10.7751019 C45.2654059,10.7713586 46.1638658,11.6637494 46.1676092,12.7683126 C46.1676168,12.7705719 46.1676206,12.7728311 46.1676206,12.7750904 L46.1676206,26.1161271 C46.1676206,27.2206966 45.2721901,28.1161271 44.1676206,28.1161271 L10.1547592,28.1161271 C9.77142209,28.1161271 9.39616036,28.0059618 9.07365485,27.7987481 L5.59587074,25.5642298 C4.77208291,25.0349362 4.45264078,23.9870373 4.84107879,23.088208 L8.37689688,14.9064731 C8.53455602,14.5416565 8.79732999,14.2320826 9.13168883,14.017253 Z"
                      id="Rectangle-9"
                      stroke="#354052"
                      stroke-width="2"
                      fill="#FF9C63"
                      transform="translate(25.422182, 19.445609) rotate(5.000000) translate(-25.422182, -19.445609) "
                    ></path>
                    <path
                      d="M6.61711326,18.941469 L10.6042518,16.3796844 C10.9267573,16.1724707 11.302019,16.0623054 11.6853561,16.0623054 L45.6982176,16.0623054 C46.8027871,16.0623054 47.6982176,16.9577359 47.6982176,18.0623054 L47.6982176,31.4101315 C47.6982176,32.514701 46.8027871,33.4101315 45.6982176,33.4101315 L11.6853561,33.4101315 C11.302019,33.4101315 10.9267573,33.2999662 10.6042518,33.0927525 L6.61711326,30.5309678 C6.04443243,30.1630135 5.69821758,29.5290477 5.69821758,28.8483468 L5.69821758,20.62409 C5.69821758,19.9433891 6.04443243,19.3094234 6.61711326,18.941469 Z"
                      id="Rectangle-9"
                      stroke="#354052"
                      stroke-width="2"
                      fill="#FFD580"
                      transform="translate(26.698218, 24.736218) rotate(25.000000) translate(-26.698218, -24.736218) "
                    ></path>
                    <path
                      d="M0.89986607,23.6905688 L5.4012903,20.7983494 C5.72379581,20.5911357 6.09905754,20.4809704 6.48239462,20.4809704 L43.9809704,20.4809704 C45.0855399,20.4809704 45.9809704,21.3764009 45.9809704,22.4809704 L45.9809704,37.4809704 C45.9809704,38.5855399 45.0855399,39.4809704 43.9809704,39.4809704 L6.48239462,39.4809704 C6.09905754,39.4809704 5.72379581,39.3708051 5.4012903,39.1635914 L0.89986607,36.271372 C0.327185238,35.9034176 -0.0190296114,35.2694519 -0.0190296114,34.588751 L-0.0190296114,25.3731898 C-0.0190296114,24.6924889 0.327185238,24.0585232 0.89986607,23.6905688 Z"
                      id="Rectangle-9"
                      stroke="#354052"
                      stroke-width="2"
                      fill="#2AE2D3"
                      transform="translate(22.980970, 29.980970) rotate(45.000000) translate(-22.980970, -29.980970) "
                    ></path>
                    <circle id="Oval-3-Copy-4" stroke="#884FB0" stroke-width="2" cx="4" cy="41" r="3"></circle>
                    <circle id="Oval-3-Copy-5" stroke="#2AE2D3" stroke-width="2" cx="51" cy="2" r="2"></circle>
                    <circle id="Oval-3-Copy-3" fill="#FFD580" cx="5.5" cy="2.5" r="2.5"></circle>
                    <circle id="Oval-4" stroke="#354052" stroke-width="1.5" cx="11.5" cy="18.5" r="2.5"></circle>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div class="settings-popup__description-group dialog__description-group">
          <div class="settings-popup__description-text dialog__description-text">Теги для организованности</div>
          <div class="settings-popup__description-content dialog__description-content">
            Добавьте тэги к задачам, чтобы лучше структурировать рабочий процесс
          </div>
        </div>
      </div>
      <app-setting-tag></app-setting-tag>
    }
  }
</div>
